import { Sentry } from './config/sentry';

const sendToSentry = ({ name, delta, id, value }) => {
  Sentry.metrics?.distribution(`web_vitals.${name}`, value ?? delta, {
    tags: { metric_id: id },
    unit: name === 'CLS' ? '' : 'millisecond',
  });

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(`[web-vitals] ${name}:`, Math.round(name === 'CLS' ? delta * 1000 : delta));
  }
};

const reportWebVitals = onPerfEntry => {
  const handler = onPerfEntry || sendToSentry;

  if (handler && handler instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(handler);
      getFID(handler);
      getFCP(handler);
      getLCP(handler);
      getTTFB(handler);
    });
  }
};

export default reportWebVitals;
